import { useMutation } from '@tanstack/react-query';

export default function useUpdateOrganizationStaffResetPassword() {
  const token = (document.getElementsByName('csrf-token')[0] as HTMLMetaElement).content;
  return useMutation({
    mutationFn: async (params: { id: number; password: string; password_confirmation: string }) => {
      const response = await fetch(`/agent/api/organization_users/${params.id}/reset_password`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-CSRF-Token': token,
        },
        body: JSON.stringify({
          password: params.password,
          password_confirmation: params.password_confirmation,
        }),
      });
      if (!response.ok) {
        throw new Error('Failed to reset password');
      }
      return await response.json();
    },
  });
}
